// removed by extract-text-webpack-plugin
module.exports = {"bylines":"_2VptB","byline":"_32Jxp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Bylines/Bylines.scss
 ** module id = 98
 ** module chunks = 0
 **/